module.exports = __webpack_public_path__ + "static/media/ev-catalog-screenshot.a758ee3c.png";